import React from "react";
import { useState } from "react";
import Styles from "../../Styles/Resume.module.css"
import edit from "../../Assets/edit.png"
import del from "../../Assets/delete.png";
import add from "../../Assets/add.png";


const Certify = () => {
    const [workCertify, setWorkCertify] = useState([
      {
        title: 'Web Development ',
        platform: 'Coursera',
        startDate: 'Present',
        endDate: 'Present',
        
      },
    ]);
  
    const [newWorkCertify, setNewWorkCertify] = useState({
      title: '',
      platform: '',
      startDate: '',
      endDate: '',

    });
  
    const handleAddWorkCertify = () => {
      setWorkCertify([...workCertify, newWorkCertify]);
      setNewWorkCertify({
        title: '',
        platform: '',
        startDate: '',
        endDate: '',
       
      });
    };
  
    const handleEditWorkCertify = (index) => {
      const updatedWorkCertify = [...workCertify];
      updatedWorkCertify[index] = newWorkCertify;
      setWorkCertify(updatedWorkCertify);
    };
  
    const handleDeleteWorkCertify = (index) => {
      const updatedWorkCertify = [...workCertify];
      updatedWorkCertify.splice(index, 1);
      setWorkCertify(updatedWorkCertify);
    };

    const [modalOpen,  setModalOpen  ] = useState(false)

    const handleCloseModal = () => {
      setModalOpen(false);
    };
   
   
  
    return (
        <div className={Styles.contents7}>
         {workCertify.map((certify, index) => ( 
       <><div key={index} className={Styles.subcontent}>
                 <div className={Styles.subcontent1}>
                     <h1>Certifications / Licenses</h1>
                 </div>
                 <div className={Styles.subcontent2}>
                     <img src={add} onClick={() => setModalOpen(true)}  alt="/" width="23.0px" height="23.0px" />
                 </div>
             </div><div className={Styles.subcontent01}>
                     <hr style={{ width: "605px" }}></hr>
                 </div><div className={Styles.subcontent02}>
                     <div className={Styles.subcontent1}>
                         <div className={Styles.text}>
                             <div className={Styles.headertext}>
                                 <h1 style={{ whiteSpace: "nowrap" }}>{certify.title}</h1>
                                 <div className={Styles.icon} style={{ whiteSpace: "nowrap" }}>
                                     <img src={edit} alt="/" width="23.0px" height="23.0px" style={{ position: 'relative', right: "30px" }} onClick={() => handleEditWorkCertify()}  />
                                     <img src={del} alt="/" width="20.0px" height="20.0px" onClick={() => handleDeleteWorkCertify(index)}/>
                                 </div>
                             </div>
                             <p>{certify.platform}</p>
                             <p>{certify.startDate} to {certify.endDate}</p>
                         </div>
                     </div>
                 </div></>
         ))}
        

      {modalOpen && <div id={Styles.ModalContainer} >
        <div id={Styles.Modal}  >
        <label>Title</label>
          <input type="text" value={newWorkCertify.title} onChange={(e) => setNewWorkCertify({ ...newWorkCertify, title: e.target.value })} />
          <label>Platform</label>
          <input type="text" value={newWorkCertify.platform} onChange={(e) => setNewWorkCertify({ ...newWorkCertify, platform: e.target.value })} />
          <label>StartDate</label>
          <input type="text" value={newWorkCertify.startDate} onChange={(e) => setNewWorkCertify({ ...newWorkCertify, startDate: e.target.value })} />
          <label>EndDate</label>
          <input type="text" value={newWorkCertify.endDate} onChange={(e) => setNewWorkCertify({ ...newWorkCertify, endDate: e.target.value })} />
          <button onClick={handleAddWorkCertify} className={Styles.btn1}>Add</button>
            <button onClick={handleCloseModal} className={Styles.btn2}>close</button>
        </div>
        </div>}
            </div>
    );
  }
export default Certify;